import {
  forwardRef,
  ForwardRefRenderFunction,
  PropsWithChildren,
  ReactElement,
  ReactNode,
  Ref,
} from 'react'
import { Moment } from 'moment'
import BaseForm, {
  FormInstance,
  FormProps as BaseFormProps,
  List,
  useForm,
} from 'antd/lib/form/Form'

export interface FormProps<
  /* eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */
  Values = any
> extends Omit<BaseFormProps<Values>, 'layout' | 'autoComplete'> {
  children?: ReactNode
}

const InternalForm: ForwardRefRenderFunction<FormInstance, FormProps> = (
  { component = 'div', ...props },
  ref
): JSX.Element => (
  <>
    <BaseForm
      ref={ref}
      component={component}
      layout="vertical"
      autoComplete="off"
      requiredMark="optional"
      {...props}
    />
  </>
)

const Form = forwardRef<FormInstance, FormProps>(InternalForm) as <
  Values = string | number | boolean | Date | Moment
>(
  props: PropsWithChildren<FormProps<Values>> & {
    ref?: Ref<FormInstance<Values>>
  }
) => ReactElement

export default Form

export { useForm, List }

export type { FormInstance }
